<template>
  <ul class="main-nav__social list-inline">
    <!-- <li class="wishlist">
      <span
        ><a target="_blank" href="https://bit.ly/4amaJMr">
          Wishlist Frostline
        </a></span
      >
    </li> -->
    <li v-for="link in socialLinksList">
      <a
        :href="link.url"
        target="_blank"
        :aria-label="link.label"
        rel="nofollow me noopener noreferrer"
        v-html="link.icon"
      ></a>
    </li>
  </ul>
</template>

<script>
import generateList from "../../utils/iconListGenerator";

export default {
  name: "main-nav-socials-links",
  props: {
    links: Array,
  },
  computed: {
    socialLinksList() {
      return this.generateList(this.links);
    },
  },
  methods: {
    generateList,
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.list-inline {
  @include list-inline;
}

.main-nav__social {
  margin-left: 0;
  padding-top: 25px;
  // border-top: 1px solid $mainRed;

  .wishlist {
    a {
      margin-top: 30px;
      color: #d2efa9;
      // font-weight: bold;
      background-color: #75b022;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
      // background-color: #75b022;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
      // background-color: -webkit-linear-gradient(top, #6fa720 5%, #588a1b 95%);
      // background-color: linear-gradient(to bottom, #6fa720 5%, #588a1b 95%);
      // background-color: linear-gradient(to right, #6fa720 5%, #588a1b 95%);
      background-image: linear-gradient(
        to right,
        rgb(111, 167, 32) 5%,
        rgb(88, 138, 27) 95%
      );
      border-radius: 2px;
      text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
      background-size: contain;
      width: max-content;
      padding: 10px 20px;
      text-transform: unset;
      font-size: 22px;
      &:hover,
      &:focus {
        color: #fff;
        background-image: #6aa621;
        background-image: -webkit-linear-gradient(top, #8ed629 5%, #6aa621 95%);
        background-image: linear-gradient(to bottom, #8ed629 5%, #6aa621 95%);
        background-image: linear-gradient(to right, #8ed629 5%, #6aa621 95%);
        // background-color: lighten(#75b022, 2%);
      }
      @media (max-width: 1200px) {
        font-size: 15px;
      }
    }
  }

  li {
    padding: 0;

    &:not(:last-child) {
      padding-right: 24px;
    }
  }

  a {
    font-size: 27px;
    color: #676767;
  }
}
</style>

<style>
.main-nav__social svg {
  width: 1em;
  height: 1em;
  fill: currentColor;
  margin-bottom: -0.125em;
}
</style>
